import {
  useMemo,
  useCallback,
} from 'react';

import useTwilioVideoCall from 'components/twilio/hooks/useTwilioVideoCall';

const useGroupVideoCallSwitch = () => {
  const { createGroupVideoCall: twilioGroupVideoCall } = useTwilioVideoCall();

  const createGroupVideoCall = useCallback(async (roomName: string, boothId: string) => {
    await twilioGroupVideoCall(roomName, boothId);
  }, [twilioGroupVideoCall]);

  return useMemo(() => createGroupVideoCall, [createGroupVideoCall]);
};

export default useGroupVideoCallSwitch;
